import React from "react";
import ReactDOM from "react-dom";
import { Provider } from "react-redux"
import { store } from "./store"
import { BrowserRouter, Route, Switch, Redirect, HashRouter } from "react-router-dom";

// styles for this kit
import "assets/css/bootstrap.min.css";
import "assets/scss/now-ui-kit.scss?v=1.4.0";
import "assets/demo/demo.css?v=1.4.0";
import "assets/demo/nucleo-icons-page-styles.css?v=1.4.0";
// pages for this kit
import LoginPage from "views/pages/LoginPage.js";
import LandingPage from "views/pages/LandingPage.js";
import ProfilePage from "views/pages/ProfilePage.js";
import UserPage from "views/pages/UserPage.js";
import CounsellingRoomPage from "views/pages/CounsellingRoomPage.js";
import ChangePasswordPage from "views/pages/ChangePasswordPage";

ReactDOM.render(
  <Provider store={store}>
    <BrowserRouter>
      <HashRouter>
        <Switch>
          <Switch>

            <Route
              path="/landing-page"
              render={(props) => <LandingPage {...props} />}
            />
            <Route
              path="/profile-page"
              render={(props) => <ProfilePage {...props} />}
            />
            <Route
              path="/user-page"
              render={(props) => <UserPage {...props} />}
            />
            <Route
              path="/login-page"
              render={(props) => <LoginPage {...props} />}
            />
             <Route
              path="/counselling-room-page"
              render={(props) => <CounsellingRoomPage {...props} />}
            />
             <Route
              path="/change-password-page"
              render={(props) => <ChangePasswordPage {...props} />}
            />
            <Redirect to="/landing-page" />
            <Redirect from="/" to="/landing-page" />
          </Switch>
        </Switch>
      </HashRouter>

    </BrowserRouter>
  </Provider>,
  document.getElementById("root")
);
